import React, { useState } from 'react';
import Settings from './UserSettings';
import ProfileSettings from '../users/UpdateUserForm';
import UserForm from '../users/UsersForm';
import ArtisanForm from '../users/ArtisanForm';
import SupplierForm from '../users/SupplierForm';
import CustomerForm from '../users/CustomerForm';
import { AppBar, makeStyles, Tab, Tabs } from '@material-ui/core';
import {
  artisanDataSelector,
  authCurrentUserSelector,
  customerDataSelector,
  supplierDataSelector,
  applicantDataSelector
} from '../../../modules/auth/Selectors';
import { connect } from 'react-redux';
import getLangData from '../../../utils/getLangData';
import ApplicantForm from '../users/ApplicantForm';

const Index = props => {
  const {
    artisanData,
    supplierData,
    userData,
    customerData,
    applicantData
  } = props;
  // const [open, setOpen] = useState(false);
  // const [types, setTypes] = useState(['2', '3', '4', '5', '6']);

  const [activeTab, setActiveTab] = useState(1);
  const onClickTabs = tab => {
    setActiveTab(tab);
  };
  const userType = localStorage.getItem('defaultType');
  const useStyles = makeStyles({
    active: {
      fontWeight: 'bold',
      textTransform: 'capitalize',
      borderBottom: '2px solid black'
    },
    label: {
      fontWeight: 'bold',
      textTransform: 'capitalize'
    },
    modalBtn: {
      backgroundColor: '#ecc063',
      borderRadius: '100px',
      paddingRight: '20px',
      paddingLeft: '20px',
      fontWeight: '600',
      display: 'block',
      marginLeft: 'auto',
      marginTop: '15px'
    }
  });
  const classes = useStyles();
  // const { profiles, ...userData } = currentUser;
  // const artisanData = currentUser.profiles?.artisan;
  // const supplierData = currentUser.profiles?.supplier;
  // const customerData = currentUser.profiles?.customer;
  // const applicantData = currentUser.profiles?.applicant;
  // const trainingCenterData = currentUser.profiles?.trainingCenter;
  return (
    <>
      <AppBar position='static' color='default'>
        <Tabs
          indicatorColor='primary'
          variant='scrollable'
          scrollButtons='auto'
        >
          <Tab
            className={activeTab === 1 ? classes.active : classes.label}
            onClick={() => onClickTabs(1)}
            label={getLangData().fields.data}
          >
            User Form
          </Tab>
          {userType === '3' && (
            <Tab
              className={activeTab === 2 ? classes.active : classes.label}
              label={getLangData().profile_types.artisan}
              onClick={() => onClickTabs(2)}
            >
              item 2
            </Tab>
          )}

          {userType === '5' && (
            <Tab
              className={activeTab === 3 ? classes.active : classes.label}
              label={getLangData().profile_types.supplier}
              onClick={() => onClickTabs(3)}
            >
              item 3
            </Tab>
          )}
          {userType === '6' && (
            <Tab
              className={activeTab === 6 ? classes.active : classes.label}
              label={getLangData().profile_types.applicant}
              onClick={() => onClickTabs(6)}
            >
              item 6
            </Tab>
          )}
          {userType === '4' && (
            <Tab
              className={activeTab === 4 ? classes.active : classes.label}
              label={getLangData().profile_types.customer}
              onClick={() => onClickTabs(4)}
            />
          )}
          <Tab
            className={activeTab === 5 ? classes.active : classes.label}
            label={getLangData().menu.side.settings}
            onClick={() => onClickTabs(5)}
          />
          {/* <Tab onClick={()=> window.location.reload()} label="click me" /> */}
        </Tabs>
      </AppBar>{' '}
      {activeTab === 1 && (
        <ProfileSettings
          // setPage={setPage}
          // page={page}
          // userData={userData}
          edit={true}
        />
      )}
      {activeTab === 2 && (
        <ArtisanForm
          // setPage={setPage}
          // page={page}
          artisanData={artisanData}
          edit={artisanData?._id ? true : false}
        />
      )}
      {activeTab === 4 && (
        <CustomerForm
          customerData={customerData}
          edit={customerData?._id ? true : false}
        />
      )}
      {activeTab === 3 && (
        <SupplierForm
          // setPage={setPage}
          // page={page}
          supplierData={supplierData}
          edit={supplierData?._id ? true : false}
        />
      )}
      {activeTab === 5 && (
        <Settings
        // setPage={setPage}
        // page={page}
        // supplierData={supplierData}
        // edit={supplierData?._id ? true : false}
        />
      )}
      {activeTab === 6 && (
        <ApplicantForm
          applicantData={applicantData}
          edit={applicantData?._id ? true : false}
        />
      )}
      {/* {activeTab === 8 && (
        <TrainingCenterForm
          setPage={setPage}
          page={page}
          trainingCenterData={trainingCenterData}
          edit={trainingCenterData?._id ? true : false}
        />
      )} */}
    </>
  );
};

const mapStateToProps = state => {
  return {
    artisanData: artisanDataSelector(state),
    supplierData: supplierDataSelector(state),
    applicantData: applicantDataSelector(state),
    userData: authCurrentUserSelector(state),
    customerData: customerDataSelector(state)
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
